import type { Compare, Granularity } from '../types';

export const getComparison = ({
  granularity,
  window,
  start,
  end,
  comparePeriod,
}: {
  granularity: Granularity;
  window: number | null;
  start: string | null;
  end: string | null;
  comparePeriod?: string | null;
}): Compare => {
  if (!comparePeriod) return;

  if (comparePeriod === 'previous' && window) return window;

  const match = comparePeriod.match(/year-(\d+)/);
  if (granularity === null || start || end || match === null) {
    return;
  }

  const calculateCompare = (n: number) => ({
    year: 1 * n,
    half_year: 2 * n,
    quarter: 4 * n,
    month: 12 * n,
    week: Math.round(52.18 * n),
    day: Math.round(365.25 * n),
    null: undefined,
  });

  const n = parseInt(match[1], 10);

  return calculateCompare(n)[granularity];
};
